import classnames from 'classnames';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useState } from 'react';
import styles from './styles.scss';

type IProps = {
	children?: Element;
}

const SafeguardSection: FC = (props: IProps) => {
	const { t, list, transData } = useTranslation('home.safeguard');
	const itemList = useMemo(() => {
		if (!Array.isArray(list)) return []
		return list.map((item, index) => {
			return (
				<div className={classnames(styles['ac-safeguard-item'], styles[`ac-safeguard-item-${item.id}`])} key={index} style={{ backgroundColor: item.backgroundColor }}>
					<div className={styles['ac-safeguard-item-icon']}>
						{item.icon.map((icon: any, index: React.Key | undefined) => {
							return (
								<div className={styles[`item-icon-${index}`]} key={index} ></div>
							)
						})}

					</div>
					<div className={styles['ac-safeguard-item-content']}>
						<img className={styles['item-icon']} loading='lazy' src={item.img} alt="" />
						<div className={styles['item-content']}>
							<h2>{item.title}</h2>
							<p>{item.content}</p>
						</div>
					</div>
				</div>)
		})
	}, [list])


	return (
		<section className={classnames(styles['ac-safeguard'], 'ac-safeguard')}>
			<div className={styles['ac-safeguard-container']}>
				{props.children || <h1>{transData.title.h1}<span> {transData.title.span}</span><p> {transData.title.p}</p></h1>}
				<div className={styles['ac-safeguard-list']}>
					{itemList}
				</div>
			</div>
		</section>
	);
}

export default SafeguardSection
